<template>
<div class="footer-wrapper">
  <div class="footer-tgo">
    <div class="footer-desc container">
      <div class="left">
        <p class="logo"><img src="./assets/logo-geekbang-tgo.png" alt=""></p>
        <h1>构建全球化的有技术背景的优秀人才同侪学习成长平台</h1>
        <hr>
        <p>TGO 是极客邦旗下科技领导者聚集和交流的组织，学员由 CTO、架构师、技术 VP、具有技术背景的 CEO 等组成，目前已经在北京、上海、深圳、广州、杭州、成都、硅谷、南京、台北、厦门、武汉、苏州等城市定期举办学习活动。</p>
      </div>
      <div class="right">
        <div class="qr is-first">
          <p><img src="./assets/qrcode-ego.png"></p>
          <p>TGO 客服</p>
        </div>
        <div class="qr">
          <p><img src="./assets/qrcode-contact.jpeg"></p>
          <p>TGO 微信公众号</p>
        </div>
      </div>
    </div>
    <!-- <div class="footer-list container" v-if="false">
      <div class="footer-item" v-for="(items, i) in footerList" :key="i">
        <h4>{{items.title}}</h4>
        <ul>
          <li v-for="(item, index) in items.list" :key="`${item}-${index}`">{{item}}</li>
        </ul>
      </div>
    </div> -->
  </div>
  <div class="copyright">
    <p class="container">{{`Copyright &copy; ${year}, Geekbang Technology Ltd. All rights reserved. 极客邦控股（北京）有限公司 | `}}<a class="beian" target="_blank" href="http://www.beian.miit.gov.cn">京 ICP 备 16027448 号- 5.</a></p>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      year: new Date().getFullYear(),
      footerList: [
        {
          title: '学员&全球分会',
          list: ['全球学员', '分会理事学员', '新会成立']
        },
        {
          title: '培训体系',
          list: ['TGO培训团', 'TGO培训章程&教材']
        },
        {
          title: '加入我们',
          list: ['学员权益', '加入我们', '联系TGO']
        },
        {
          title: '关于TGO',
          list: ['TGO全球', '运营情况', '常⻅问题', '隐私条款&使用条款', '年度报告']
        },
        {
          title: 'TGO小组',
          list: ['小组说明章程', '常规&跨组&兴趣小组']
        }
      ]
    }
  },
  methods: {
  }
}
</script>
<style lang="sass" scoped>
@import "../../style/bulma/sass/utilities/_all"

.container
  width: 1080px
  max-width: 1080px
  +mobile
    width: 92vw !important
    max-width: 92vw !important

.footer-wrapper
  .copyright
    padding: 10px 0
    text-align: center
    background-color: #ccc
    .beian
      color: #495060
    +mobile
      font-size: 12px

.footer-tgo
  // height: 310px
  background-color: rgb(53,53,53)
  padding: 30px 0
  color: #d9d9d9
  +mobile
    height: auto
    padding: 6vw 4vw
  .footer-desc
    display: flex
    align-items: center
    margin-bottom: 40px
    .left
      flex-basis: 0
      flex-grow: 1
      flex-shrink: 1
      margin-right: 180px
      h1
        margin-top: 26px
        font-size: 20px
      hr
        margin: 6px 0 10px 0
      p
        font-size: 14px
        &.logo
          width: 60%
    .right
      display: flex
      flex-basis: 280px
      flex-grow: 0
      flex-shrink: 0
      text-align: center
      font-size: 14px
      align-self: flex-start
      .qr
        +tablet
          flex-basis: 0
          flex-grow: 1
      .qr.is-first
        margin-right: 15px
        +mobile
          display: none
      p
        width: 100%
        margin-top: 10px
    +mobile
      &
        width: 92vw
      .left
        margin-right: 8vw
        text-align: justify
        h1
          margin-top: 6px
          font-size: 14px
          letter-spacing: 0px !important
        hr
          margin: 10px 0 5px 0
        p
          font-size: 12px
      .right
        flex-basis: 24vw
        font-size: 12px
        img
          margin-top: 1vw
        p
          margin-top: 0px
          width: 100%
  .footer-list
    display: flex
    justify-content: space-between
    font-size: 12px
    h4
      margin-bottom: 14px
      font-size: 14px
      color: #fff
      font-weight: bold
    li
      margin-bottom: 8px
      opacity: 0.8
</style>
